const getSubtitle = (queryParam: any) => {
  if (queryParam.badges && queryParam?.badges.lenght == 2) {
    return `resenha skoob, comprou e avaliou`;
  }
  if (queryParam?.badges == 'skoob') {
    return 'resenha skoob';
  }
  if (queryParam?.badges == 'verified_purchaser') {
    return 'comprou e avaliou';
  }
  return '';
};

export default getSubtitle;
export { getSubtitle };
